exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-label[data-v-6a0ff07d] {\n  left: 0px;\n  right: auto;\n  position: absolute;\n}\n", ""]);

// exports
